import { SchoolService } from './../service/school.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from '../service/base.service';

@Injectable()
export class SchoolDetailResolver implements Resolve<ApiObjectData> {
  constructor(
    private service: SchoolService,
    private baseService: BaseService
  ) { }
  resolve(route: ActivatedRouteSnapshot): Observable<ApiObjectData> {
    return this.baseService.resolveGet(this.service, route, '/page/schools');
  }
}

@Injectable({
  providedIn: 'root'
})
export class SchoolResolver implements Resolve<ApiObjectData> {
  constructor(
    private service: SchoolService,
    private baseService: BaseService
  ) { }
  resolve(): Observable<ApiObjectData> {
    return this.baseService.resolveGets(this.service);
  }
}

@Injectable({ providedIn: 'root' })
export class AllTeachersResolver implements Resolve<ApiObjectData> {
  constructor(private service: SchoolService) {}

  resolve(): Observable<ApiObjectData> {
    return this.service.getAllTeachers();
  }
}
